import { LinksSchemaType } from "../type";

export const tourLinksArray: LinksSchemaType = {
  main: "/tour",
  maintitle: "صفحه اصلی تور",
  mainImage: `${process.env.NEXT_PUBLIC_BASE_URL_STORE}/assets/menu/tour-desktop.png`,
  mainImageMobile: `${process.env.NEXT_PUBLIC_BASE_URL_STORE}/assets/menu/tour-mobile.png`,
  otherlinks: [
    {
      title: "رزرو تور استانبول از تهران",
      href: "/tour/THR/IST",
      img: `${process.env.NEXT_PUBLIC_BASE_URL_STORE}/assets/menu/tehran-istanbul.png`
    },
    {
      title: "رزرو تور مشهد از تهران",
      href: "/tour/THR/MHD",
      img: `${process.env.NEXT_PUBLIC_BASE_URL_STORE}/assets/menu/tehran-mashhad.png`
    },
    {
      title: "رزرو تور کیش از تهران",
      href: "/tour/THR/KIH",
      img: `${process.env.NEXT_PUBLIC_BASE_URL_STORE}/assets/menu/tehran-kish.png`
    },
    {
      title: "رزرو تور مشهد از شیراز",
      href: "/tour/SYZ/MHD",
      img: `${process.env.NEXT_PUBLIC_BASE_URL_STORE}/assets/menu/mashhad.png`
    },
    {
      title: "رزرو تور کیش از مشهد",
      href: "/tour/MHD/KIH",
      img: `${process.env.NEXT_PUBLIC_BASE_URL_STORE}/assets/menu/kish.png`
    },
    {
      title: "رزرو تور کیش از شیراز",
      href: "/tour/SYZ/KIH",
      img: `${process.env.NEXT_PUBLIC_BASE_URL_STORE}/assets/menu/kish.png`
    }
  ]
};
